import { useEffect, useState } from 'react';

/**
 * Tracks whether the browser tab is currently visible, driven by the Page
 * Visibility API. Used to pause background polling while the tab is hidden and
 * resume it the moment the driver returns.
 */
const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(() => !document.hidden);

  useEffect(() => {
    const handleVisibilityChange = () => setIsVisible(!document.hidden);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isVisible;
};

export default usePageVisibility;
